import { createAsyncThunk } from '@reduxjs/toolkit';
import ClientApi from '@infrastructure/client-api';
import { addSuccessNotification } from '../common/notificationSlice';
import { translate } from '@application/common/helpers/translate';
import { getErrorPayload } from '@application/common/helpers/api-helper';
export const addClientAsync = createAsyncThunk('client/add', async (client, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ClientApi.addClient(client);
        dispatch(addSuccessNotification(translate('client.clientCreatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getClientsAsync = createAsyncThunk('client/get', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ClientApi.getClients();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getUnassignedClientsAsync = createAsyncThunk('client/getUnassigned', async (Id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ClientApi.getUnassignedClients(Id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getClientByIdAsync = createAsyncThunk('client/getById', async (Id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ClientApi.getClientById(Id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateClientAsync = createAsyncThunk('client/update', async (client, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ClientApi.updateClient(client);
        dispatch(addSuccessNotification(translate('client.clientUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
